import { Suspense, lazy } from "react";
import { Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import PermissionGuard from "@/shared/components/PermissionGuard";
import { useInstitutionAccess } from "@/shared/hooks/useInstitutionAccess";

const DetalheInstituicao = lazy(() => import("@/interno/instituicoes/paginas/DetalheInstituicao"));

const LazyFallback = (
  <div className="flex items-center justify-center py-20">
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
  </div>
);

/**
 * Permite que usuários institution_external acessem a página da sua instituição
 * sem precisar de permissão ao módulo instituicoes. Outros usuários passam pelo PermissionGuard.
 *
 * Aguarda `useInstitutionAccess` terminar antes de decidir — senão o externo vê "Acesso restrito"
 * por um frame (ou de forma persistente se a ordem de hidratação falhar).
 */
const InstitutionRouteGuard = () => {
  const { id } = useParams<{ id: string }>();
  const { isExternalUser, institutionId, loading: accessLoading } = useInstitutionAccess();

  if (accessLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isExternalUser && institutionId === id) {
    return <Suspense fallback={LazyFallback}><DetalheInstituicao /></Suspense>;
  }

  return (
    <PermissionGuard module="instituicoes">
      <Suspense fallback={LazyFallback}><DetalheInstituicao /></Suspense>
    </PermissionGuard>
  );
};

export default InstitutionRouteGuard;
